"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.codeLookup = exports.generateDataRequirement = exports.addFhirQueryPatternToDataRequirements = exports.generateDetailedValueFilter = exports.generateDetailedDateFilter = exports.generateDetailedCodeFilter = exports.flattenFilters = void 0;
var PatientReferences_1 = require("../compartment-definition/PatientReferences");
var FHIR_QUERY_PATTERN_URL = 'http://hl7.org/fhir/us/cqfmeasures/StructureDefinition/cqfm-fhirQueryPattern';
/**
 * Take any nesting of base filters and AND filters and flatten into one list
 *
 * @param filter the root filter to flatten
 * @returns a list of all filters used by this query at one level
 */
function flattenFilters(filter) {
    if (filter.type !== 'and') {
        return [filter];
    }
    else {
        var a_1 = [];
        filter.children.forEach(function (c) {
            a_1.push.apply(a_1, flattenFilters(c));
        });
        return a_1;
    }
}
exports.flattenFilters = flattenFilters;
/**
 * Map an EqualsFilter or InFilter into a FHIR DataRequirement codeFilter
 *
 * @param filter the filter to translate
 * @returns codeFilter to be put on the DataRequirement
 */
function generateDetailedCodeFilter(filter, dataType) {
    var _a;
    var system = dataType ? codeLookup(dataType, filter.attribute) : null;
    if (filter.type === 'equals') {
        var equalsFilter = filter;
        if (typeof equalsFilter.value === 'string') {
            return {
                path: equalsFilter.attribute,
                code: [
                    __assign({ code: equalsFilter.value }, (system && { system: system }))
                ]
            };
        }
    }
    else if (filter.type === 'in') {
        var inFilter = filter;
        if ((_a = inFilter.valueList) === null || _a === void 0 ? void 0 : _a.every(function (v) { return typeof v === 'string'; })) {
            return {
                path: inFilter.attribute,
                code: inFilter.valueList.map(function (v) { return (__assign({ code: v }, (system && { system: system }))); })
            };
        }
        else if (filter.valueCodingList) {
            return {
                path: filter.attribute,
                code: filter.valueCodingList
            };
        }
    }
    return null;
}
exports.generateDetailedCodeFilter = generateDetailedCodeFilter;
/**
 * Map a during filter into a FHIR DataRequirement dateFilter
 *
 * @param filter the "during" filter to map
 * @returns dateFilter for the dateFilter list of dataRequirement
 */
function generateDetailedDateFilter(filter) {
    return {
        path: filter.attribute,
        valuePeriod: { start: filter.valuePeriod.start, end: filter.valuePeriod.end }
    };
}
exports.generateDetailedDateFilter = generateDetailedDateFilter;
/**
 * Map a filter into a FHIR DataRequirement valueFilter extension
 *
 * @param filter the filter to map
 * @returns extension for the valueFilter list of dataRequirement
 */
function generateDetailedValueFilter(filter) {
    if (filter.type === 'notnull') {
        var notnullFilter = filter;
        return {
            url: 'http://hl7.org/fhir/us/cqfmeasures/StructureDefinition/cqfm-valueFilter',
            extension: [
                { url: 'path', valueString: notnullFilter.attribute },
                { url: 'comparator', valueCode: 'eq' },
                { url: 'value', valueString: 'not null' }
            ]
        };
    }
    else if (filter.type === 'value') {
        var valueFilter = filter;
        var valueExtension = {
            url: 'value',
            valueBoolean: valueFilter.valueBoolean,
            valueInteger: valueFilter.valueInteger,
            valueString: valueFilter.valueString,
            valueQuantity: valueFilter.valueQuantity,
            valueRange: valueFilter.valueRange,
            valueRatio: valueFilter.valueRatio
        };
        return {
            url: 'http://hl7.org/fhir/us/cqfmeasures/StructureDefinition/cqfm-valueFilter',
            extension: [
                { url: 'path', valueString: valueFilter.attribute },
                { url: 'comparator', valueCode: valueFilter.comparator },
                // Remove undefineds
                JSON.parse(JSON.stringify(valueExtension))
            ]
        };
    }
    else if (filter === null || filter === void 0 ? void 0 : filter.withError) {
        return filter.withError;
    }
    else {
        return { message: "Detailed value filter is not yet supported for filter type " + filter.type };
    }
}
exports.generateDetailedValueFilter = generateDetailedValueFilter;
/**
 * Creates query string for the data requirement using either the code filter code or valueSet and
 * the specified endpoint, and adds a fhirQueryPattern extension to the data requirement that
 * contains the query string.
 * @param dataRequirement  Data requirement to add FHIR Query Pattern to
 */
function addFhirQueryPatternToDataRequirements(dataRequirement) {
    var query = createQueryFromCodeFilter(dataRequirement.codeFilter, dataRequirement.type);
    // Configure query string from query object
    var queryString = "/" + query.endpoint + "?";
    for (var _i = 0, _a = Object.entries(query.params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        queryString = queryString.concat(key + "=" + value + "&");
    }
    // Add on date filters
    if (dataRequirement.dateFilter && dataRequirement.dateFilter[0].valuePeriod) {
        if (dataRequirement.dateFilter[0].valuePeriod.start) {
            queryString = queryString.concat("date=ge" + dataRequirement.dateFilter[0].valuePeriod.start + "&");
        }
        if (dataRequirement.dateFilter[0].valuePeriod.end) {
            queryString = queryString.concat("date=le" + dataRequirement.dateFilter[0].valuePeriod.end + "&");
        }
    }
    // Create an extension for each way that exists for referencing the patient
    PatientReferences_1.PatientReferences[dataRequirement.type].forEach(function (patientContext) {
        var fhirPathExtension = {
            url: FHIR_QUERY_PATTERN_URL,
            valueString: queryString.concat(patientContext + "=Patient/{{context.patientId}}")
        };
        // Add query to data requirement
        if (dataRequirement.extension) {
            dataRequirement.extension.push(fhirPathExtension);
        }
        else {
            dataRequirement.extension = [fhirPathExtension];
        }
    });
}
exports.addFhirQueryPatternToDataRequirements = addFhirQueryPatternToDataRequirements;
/**
 * Parses each element of codeFilter array for either the code or valueSet key, and creates
 * query object containing each code/valueSet and corresponding value.
 * @param codeFilterArray codeFilter array from DataRequirement
 * @param type dataRequirement type
 * @returns query object consisting of an endpoint and params object containing the code/valueSet
 * and value pairs
 */
function createQueryFromCodeFilter(codeFilterArray, type) {
    var query = { endpoint: type, params: {} };
    codeFilterArray === null || codeFilterArray === void 0 ? void 0 : codeFilterArray.map(function (codeFilter) {
        // Prefer specific code filter over valueSet
        if (codeFilter === null || codeFilter === void 0 ? void 0 : codeFilter.code) {
            query.params["" + codeFilter.path] = codeFilter.code[0].code;
        }
        else if (codeFilter === null || codeFilter === void 0 ? void 0 : codeFilter.valueSet) {
            query.params[codeFilter.path + ":in"] = codeFilter.valueSet;
        }
    });
    return query;
}
/**
 * Given a DataTypeQuery object, create a DataRequirement object that represents the data
 * that would be requested from a FHIR server for that query.
 * Currently supports
 * @param retrieve a DataTypeQuery that represents a retrieve for a FHIR Resource with certain attributes
 * @returns fhir4.DataRequirement with as much attribute data as we can add
 */
function generateDataRequirement(retrieve) {
    if (retrieve.valueSet) {
        return {
            type: retrieve.dataType,
            codeFilter: [
                {
                    path: retrieve.path,
                    valueSet: retrieve.valueSet
                }
            ]
        };
    }
    else if (retrieve.code) {
        return {
            type: retrieve.dataType,
            codeFilter: [
                {
                    path: retrieve.path,
                    code: [retrieve.code]
                }
            ]
        };
    }
    else {
        return {
            type: retrieve.dataType
        };
    }
}
exports.generateDataRequirement = generateDataRequirement;
/**
 * Given a fhir dataType as a string and an attribute as a string, returns the url which outlines
 * the code system used to define the valid inputs for the given attribute for the given dataType
 * @param dataType
 * @param attribute
 * @returns string url for code system
 */
function codeLookup(dataType, attribute) {
    var validDataTypes = ['Observation', 'Procedure', 'Encounter', 'MedicationRequest'];
    if (!validDataTypes.includes(dataType)) {
        return null;
    }
    else if (dataType === 'Observation' && attribute === 'status') {
        return 'http://hl7.org/fhir/observation-status';
    }
    else if (dataType === 'Procedure' && attribute === 'status') {
        return 'http://hl7.org/fhir/event-status';
    }
    else if (dataType === 'Encounter' && attribute === 'status') {
        return 'http://hl7.org/fhir/encounter-status';
    }
    else if (dataType === 'MedicationRequest') {
        switch (attribute) {
            case 'status':
                return 'http://hl7.org/fhir/CodeSystem/medicationrequest-status';
            case 'intent':
                return 'http://hl7.org/fhir/CodeSystem/medicationrequest-intent';
            case 'priority':
                return 'http://hl7.org/fhir/request-priority';
            default:
                return null;
        }
    }
    return null;
}
exports.codeLookup = codeLookup;
//# sourceMappingURL=DataRequirementHelpers.js.map